<script>
export default {
  name: 'TotalSumsMixin',
  data () {
    return {
      totalSums: []
    }
  },
  watch: {
    'item.invoiceType': function (val) {
      if (!this.hasId) {
        this.item.invoicePositions = []
        this.item.totalSums = []
      }
    }
  },
  methods: {
    calculateTotalSums () {
      this.item.totalSums = []
      this.item.totalValueNetto = 0.00
      this.item.totalVatAmount = 0.00
      this.item.totalValueBrutto = 0.00
      for (let vr in this.vatRates) {
        let object = {
          rangeText: this.vatRates[vr].range,
          vatRange: this.vatRates[vr].value,
          totalValueNetto: 0,
          totalVatAmount: 0,
          totalValueBrutto: 0
        }
        this.item.totalSums.push(object)
      }
      let finalObject = {
        rangeText: '-',
        vatRange: '-',
        totalValueNetto: 0,
        totalVatAmount: 0,
        totalValueBrutto: 0
      }
      this.item.totalSums.push(finalObject)
      for (let ip in this.item.invoicePositions) {
        for (let vr in this.vatRates) {
          if (this.vatRates[vr]['@id'] === this.item.invoicePositions[ip].vatRate) {
            let vatRange = this.vatRates[vr].range
            for (let tsa in this.item.totalSums) {
              if (vatRange === this.item.totalSums[tsa].rangeText) {
                this.item.totalSums[tsa].totalValueNetto = (parseFloat(this.item.totalSums[tsa].totalValueNetto) + parseFloat(this.item.invoicePositions[ip].valueNetto)).toFixed(2)
                this.item.totalSums[tsa].totalVatAmount = (parseFloat(this.item.totalSums[tsa].totalVatAmount) + parseFloat(this.item.invoicePositions[ip].vatAmount)).toFixed(2)
                this.item.totalSums[tsa].totalValueBrutto = (parseFloat(this.item.totalSums[tsa].totalValueBrutto) + parseFloat(this.item.invoicePositions[ip].valueBrutto)).toFixed(2)
                this.item.totalValueNetto = (parseFloat(this.item.totalValueNetto) + parseFloat(this.item.invoicePositions[ip].valueNetto)).toFixed(2)
                this.item.totalVatAmount = (parseFloat(this.item.totalVatAmount) + parseFloat(this.item.invoicePositions[ip].vatAmount)).toFixed(2)
                this.item.totalValueBrutto = (parseFloat(this.item.totalValueBrutto) + parseFloat(this.item.invoicePositions[ip].valueBrutto)).toFixed(2)
              }
            }
          }
        }
      }
      if (typeof this.item.totalValueNetto !== 'string') {
        this.item.totalValueNetto = (this.item.totalValueNetto).toFixed(2)
      }
      if (typeof this.item.totalValueBrutto !== 'string') {
        this.item.totalValueBrutto = (this.item.totalValueBrutto).toFixed(2)
      }
    }
  }
}
</script>

<style scoped>

</style>
